import { globalStyleSheet } from "@/assets/css/global";
import '@/components/reusable/RPlayButton';
import { player } from "@/utils/player";
import { eventEmitter } from "@/utils/eventEmitter";
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
    :host {
      display: flex;
    }
`);
export class RPlayerPlayButton extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [globalStyleSheet, styleSheet];
    }
    connectedCallback() {
        this.#abortController = new AbortController();
        this.#initDOM();
    }
    disconnectedCallback() {
        this.#abortController.abort();
    }
    /** @type {AbortController | undefined} */
    #abortController;
    /** @returns {RPlayButton} */
    get #buttonEl() {
        return this.shadowRoot.querySelector('r-play-button');
    }
    #initDOM() {
        this.shadowRoot.innerHTML = `
            <r-play-button></r-play-button>
        `;
        this.#buttonEl.isPlaying = player.playing;
        this.#buttonEl.addEventListener('click', () => {
            if (player.playing) {
                player.pause();
            }
            else {
                player.play();
            }
        }, { signal: this.#abortController.signal });
        player.addEventListener('ended', () => {
            this.#buttonEl.isPlaying = false;
        });
        player.addEventListener('playing', () => {
            this.#buttonEl.isPlaying = true;
        });
    }
}
customElements.define('r-player-play-button', RPlayerPlayButton);
